// extracted by mini-css-extract-plugin
export default {"form":"form_form__27eRU","passwordIcon":"form_passwordIcon__CQ5dn","rem_forgot":"form_rem_forgot__P9mIG"};